// The pre-React modules load once, after which the store is seeded. Components
// that have been migrated import their own dependencies directly.
async function initialize() {
  const [state, report, i18n, ui, agents] = await Promise.all([
    import("../../store/state.js"), import("../report/report-view.js"),
    import("../../i18n/index.js"), import("../../utils/dom.js"), import("../../services/agents.js"),
  ]);
  await state.initState();
  return { state, report, i18n, ui, agents };
}

export type Runtime = Awaited<ReturnType<typeof initialize>>;
let pending: Promise<Runtime> | undefined;
export function loadRuntime(): Promise<Runtime> {
  pending ??= initialize().catch(error => { pending = undefined; throw error; });
  return pending;
}
